// Status presentation: WCAG AA — Soft coloured background + DARK coloured text.
// Never uses pale text on light backgrounds. All cards read instantly on light theme.
import {
  CheckCircle2, BedDouble, Calendar, Sparkles, Trash2, Wrench, Power,
  Lock, Eye, Brush, ShieldX, HelpCircle,
} from "lucide-react";

export const STATUS_META = {
  available:           { label: "Available",          tone: "success",  Icon: CheckCircle2,   color: "emerald" },
  occupied:            { label: "Occupied",           tone: "info",     Icon: BedDouble,      color: "blue" },
  reserved:            { label: "Reserved",           tone: "warning",  Icon: Calendar,       color: "amber" },
  vacant_clean:        { label: "Vacant Clean",       tone: "success",  Icon: Sparkles,       color: "emerald" },
  vacant_dirty:        { label: "Vacant Dirty",       tone: "warning",  Icon: Trash2,         color: "amber" },
  deep_cleaning:       { label: "Deep Cleaning",      tone: "info",     Icon: Brush,          color: "violet" },
  inspection_pending:  { label: "Inspection Pending", tone: "warning",  Icon: Eye,            color: "amber" },
  maintenance:         { label: "Maintenance",        tone: "error",    Icon: Wrench,         color: "rose" },
  out_of_order:        { label: "Out of Order",       tone: "error",    Icon: Power,          color: "red" },
  out_of_service:      { label: "Out of Service",     tone: "error",    Icon: ShieldX,        color: "red" },
  blocked:             { label: "Blocked",            tone: "warning",  Icon: Lock,           color: "amber" },
  unknown:             { label: "Unknown",            tone: "neutral",  Icon: HelpCircle,     color: "zinc" },
};

export const ORDERED_STATUSES = [
  "available", "occupied", "reserved",
  "vacant_clean", "vacant_dirty",
  "deep_cleaning", "inspection_pending",
  "maintenance", "out_of_order", "out_of_service",
  "blocked",
];

/**
 * Card style tokens per status.
 *   bg      — soft tinted background
 *   border  — mid-contrast tinted border
 *   accent  — DARK coloured text used for the status label / icon (WCAG AA against bg)
 */
export const STATUS_CARD_STYLE = {
  available:          { bg: "bg-emerald-50",  border: "border-emerald-300",  accent: "text-emerald-800" },
  occupied:           { bg: "bg-sky-50",      border: "border-sky-300",      accent: "text-sky-900"     },
  reserved:           { bg: "bg-amber-50",    border: "border-amber-300",    accent: "text-amber-900"   },
  vacant_clean:       { bg: "bg-emerald-50",  border: "border-emerald-200",  accent: "text-emerald-800" },
  vacant_dirty:       { bg: "bg-amber-50",    border: "border-amber-200",    accent: "text-amber-900"   },
  deep_cleaning:      { bg: "bg-violet-50",   border: "border-violet-300",   accent: "text-violet-800"  },
  inspection_pending: { bg: "bg-amber-50",    border: "border-amber-300",    accent: "text-amber-900"   },
  maintenance:        { bg: "bg-rose-50",     border: "border-rose-300",     accent: "text-rose-800"    },
  out_of_order:       { bg: "bg-red-50",      border: "border-red-300",      accent: "text-red-800"     },
  out_of_service:     { bg: "bg-red-50",      border: "border-red-300",      accent: "text-red-800"     },
  blocked:            { bg: "bg-amber-50",    border: "border-amber-300",    accent: "text-amber-900"   },
  unknown:            { bg: "bg-slate-100",   border: "border-slate-300",    accent: "text-slate-700"   },
};

// Legacy compat: some places may still import STATUS_CARD_BG.
// Kept as a computed string for those callers.
export const STATUS_CARD_BG = Object.fromEntries(
  Object.entries(STATUS_CARD_STYLE).map(([k, v]) => [k, `${v.bg} ${v.border} ${v.accent}`])
);

export function statusOf(s) {
  return STATUS_META[s] || STATUS_META.unknown;
}

export function styleOf(s) {
  return STATUS_CARD_STYLE[s] || STATUS_CARD_STYLE.unknown;
}
